import React from 'react'
import Axios from 'axios'
import './generate-link-modal.css'
import { baseUrl } from '../../assets/Animations'

const GenerateLinkModal = (props) => {
    const [school, setSchool] = React.useState("")
    const [link, setLink] = React.useState('')

    const closeTheModal = (id) => {
        if('generate-link-modal-wrapper' === id) {
            props.setShowGenerateLinkModal(false)
        }
    }

    const copy = async () => {
        if(link !== '') {
            await navigator.clipboard.writeText(link);
            alert('Copied To Clipboard');
        }
      }

    const createTheLink = async () => {
        let newStudent = {
            familyId: Math.random().toString(16).slice(2),
            familyName: '*autogenerated*',
            waveCustomerId: '',
            students: [],
            address: {},
            primaryParentName: '',
            secondaryParentName: '',
            school: '',
            primaryEmail: '',
            secondaryEmail: '',
            primaryCellphone: '',
            secondaryCellphone: '',
            primaryHomePhone: '',
            secondaryHomePhone: '',
            familyStatus: '',
            familyNotes: '',
            hearOfUs: '',
            onboardDate: '',
            paymentType: '',
            autoPay: false,
            moreAttention: false,
            policiesSigned: false,
            groupLessons: false,
            introLesson: false,
            membership: 0,
            password: 'password',
            initialAvailability: {
                Monday: [],
                Tuesday: [],
                Wednesday: [],
                Thursday: [],
                Friday: [],
                Saturday: [],
                Sunday: []
              },
            initialAvailabilityNotes: '',
            needsToFillOutNewStudentForm: false,
            purchased: []
        }
        if(school !== '') {
            Axios.post(`${baseUrl}/school-management`, {
                newStudent: newStudent
            })
            .then((res) => {
                setLink(`https://${school}.atharo.app/newstudentform/${res.data.familyId}`)
            })
            .catch((err) => {
                console.log(err)
            })
        }
    }

    return(
        <div className="generate-link-modal-wrapper" id="generate-link-modal-wrapper" onClick={(e) => closeTheModal(e.target.id)}>
            <div className="generate-link-modal">
                <h2 onClick={() => props.setShowGenerateLinkModal(false)}>close</h2>
                <select className="generate-link-school-selector" value={school} onChange={(e) => setSchool(e.target.value)}>
                    <option value="" default>Select School</option>
                    <option value="mountainside">Mountainside</option>
                    <option value="lakeside">Lakeside</option>
                    <option value="treeside">Treeside</option>
                    <option value="greatlakes">Greatlakes</option>
                </select>
                <div style={school === '' ? {backgroundColor: 'grey'} : {backgroundColor: 'green'}} className="generate-link-button-in-modal" onClick={() => createTheLink()}>Make Link</div>
                <h4 className="link-click-to-copy" onClick={() => copy()}>{link}</h4>
            </div>
        </div>
    )
}
export default GenerateLinkModal;